import React, { useContext, useEffect, useState, useRef } from 'react'
import PokemonCard from './PokemonCard'
import { motion } from 'framer-motion'
import { PokemonContext, selectPokemon } from '../Context/PokemonContext'

function PokemonList() {
  const {pokemonList, selectPokemon, getNewPokemon} = useContext(PokemonContext)
  const [isVisible, setIsVisible] = useState(false)

  const bottomRef = useRef(null);

  const cb = (entries) => {
    const [entry] = entries
    setIsVisible(entry.isIntersecting)
    if(isVisible) {
      let start = pokemonList.length+1
      let end = pokemonList.length+31
      getNewPokemon(start,end)
    }
  }

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 1
  }


  useEffect(() => {
    const observer = new IntersectionObserver(cb, options)
    if(bottomRef.current) observer.observe(bottomRef.current)
      return () => {
    if(bottomRef.current) observer.unobserve(bottomRef.current)
    }
  }, [bottomRef, options])



  return (
    <div className='flex  shadow-[inset_0px_1px_3px_1px_#00000040] max-w-[352px] overflow-scroll h-[524px] max-h-[524px] bg-white rounded-[8px] py-[24px] px-[12px] flex-wrap flex-row gap-x-[8px] gap-y-[8px]'>

        { pokemonList.length ? 
            pokemonList.map((pokemon,index) => <PokemonCard
            key={pokemon.id}
            data={pokemon}
            index={index}
            pokedexEntry={pokemon.id} pokemonImg={pokemon.sprites.front_default} pokemonName={pokemon.name}/>
          ) : <div>

        <motion.svg
                  initial={{  rotate: '360deg' }}
                  animate={{rotate: 0}}
                  repeatCount={-1}
                  transition={{ duration: .75, delay: .1,  repeat: Infinity, repeatDelay: .5 }}
         className=' z-1' width="208" height="208" viewBox="0 0 208 208" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.1">
        <path d="M128.762 104C128.762 117.676 117.676 128.762 104 128.762C90.3244 128.762 79.2381 117.676 79.2381 104C79.2381 90.3244 90.3244 79.2381 104 79.2381C117.676 79.2381 128.762 90.3244 128.762 104Z" fill="#DC0A2D"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M104 208C156.393 208 199.738 169.257 206.947 118.857H146.035C139.917 136.169 123.407 148.571 104 148.571C84.5933 148.571 68.0835 136.169 61.9648 118.857H1.05322C8.26235 169.257 51.6067 208 104 208ZM61.9648 89.1429H1.05322C8.26235 38.7431 51.6067 0 104 0C156.393 0 199.738 38.7431 206.947 89.1429H146.035C139.917 71.8314 123.407 59.4286 104 59.4286C84.5933 59.4286 68.0835 71.8314 61.9648 89.1429ZM128.762 104C128.762 117.676 117.676 128.762 104 128.762C90.3244 128.762 79.2381 117.676 79.2381 104C79.2381 90.3244 90.3244 79.2381 104 79.2381C117.676 79.2381 128.762 90.3244 128.762 104Z" fill="#DC0A2D"/>
        </g>
        </motion.svg>
          </div>
        }
        {pokemonList.length >= 151 && <div ref={bottomRef}  className='h-1'></div>}

      </div>
  )
}

export default PokemonList